import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import Starburst from '@/components/generals/starburst'

interface LogoProps {
    className?: string
    burstClassName?: string
}

// Wordmark. Place it inside an element with the `group/logo` class to spin the burst on hover.
const Logo: FC<LogoProps> = ({ className, burstClassName }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2', className)}>
            <Starburst
                className={cn(
                    'size-7 shrink-0 text-primary transition-transform duration-500 ease-out group-hover/logo:rotate-90 motion-reduce:transition-none',
                    burstClassName
                )}
            />

            <span className='font-heading text-[1.65rem] leading-none font-black tracking-[-0.02em] uppercase wdth-125'>
                Wallop
            </span>
        </span>
    )
}

export default Logo
